import React, { FC } from 'react';

import { useIsWaitingUserPlay } from '@/scenarios/legacy-player/hooks/useIsWaitingUserPlay';

import { PlayButton } from '../../feature-player/ui/skin/play-button/component';

interface Props {
    className?: string;
}

export const VodPlayButton: FC<Props> = ({ className }) => {
    const isWaitingUserPlay = useIsWaitingUserPlay();

    return isWaitingUserPlay ? <PlayButton className={className} /> : null;
};
